import React, { PureComponent, Fragment } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '@lt/components';
import { i18n } from '@lt/localization';
import FlightTransferInfo from './FlightTransferInfo';

const baseCls = 'checkout-flight';

export default class FlightTransferInfoMobile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { showTransitions: false };

    this.toggleTransitions = this.toggleTransitions.bind(this);
  }

  toggleTransitions() {
    const { showTransitions } = this.state;
    this.setState({ showTransitions: !showTransitions });
  }

  render() {
    const { transition, transition_time, showCut } = this.props;
    const { showTransitions } = this.state;

    return (
      <div
        className={cn(`${baseCls}__transitions-container`, {
          [`${baseCls}__transitions-container--expanded`]: showTransitions,
        })}
      >
        {showTransitions && (
          <FlightTransferInfo
            transition={transition}
            transitionTime={transition_time}
            className="flight-transfer-info-mobile"
          />
        )}
        <div className="relative">
          {showCut && (
            <>
              <div className={`${baseCls}__cutout`} />
              <div className={`${baseCls}__cutout ${baseCls}__cutout--right`} />
            </>
          )}
          <div className="flex">
            {transition ? (
              <>
                <div className={`${baseCls}__separator`} />
                <Button functional onClick={this.toggleTransitions}>
                  <div className={`${baseCls}__transitions-label lt-link`}>
                    {/** TODO: несколько пересадок, когда бэк подъедет */}
                    <span>1</span>
                    <div>
                      {i18n.t('checkout.flight.transfer.mobile', {
                        context: showTransitions ? 'hide' : 'show',
                      })}
                    </div>
                  </div>
                </Button>
                <div className={`${baseCls}__separator`} />
              </>
            ) : (
              showCut && <div className={`${baseCls}__separator`} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

FlightTransferInfoMobile.defaultProps = {
  showCut: false,
  transition: null,
  transition_time: null,
};

FlightTransferInfoMobile.propTypes = {
  transition: PropTypes.shape({
    city: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  transition_time: PropTypes.shape({
    arrival: PropTypes.string,
    departure: PropTypes.string,
  }),
  showCut: PropTypes.bool,
};
